<template>
    <div class="wrapper bg-primary d-flex align-items-center">
        <div class="container align-items-center p-5">
            <div class="row justify-content-center">
                <div class="col-md-4">
                    <div class="card shadow border-0">
                        <div class="card-header border-0 text-center bg-transparent">
                            <div class="">
                                <img v-lazy="'img/brand/sic.png'" class="img-fluid">
                            </div>
                            <div class="text-center mt-3 pt-4">
                                <h3>Dashboard Login</h3>
                            </div>
                        </div>
                        <div class="card-body">
                            <form role="form">
                                <div class="form-group mb-3">
                                    <div class="input-group input-group-alternative">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="ni ni-email-83"></i></span>
                                        </div>
                                        <input v-model="email" v-validate="'required|email'" name="email"
                                               data-vv-as="Email" class="form-control" placeholder="Email" type="email">
                                    </div>
                                    <small v-if="errors.has('email')" class="text-danger">
                                        {{ errors.first('email') }}
                                    </small>
                                </div>
                                <div class="form-group mb-3">
                                    <div class="input-group input-group-alternative">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="ni ni-lock-circle-open"></i></span>
                                        </div>
                                        <input v-model="password" v-validate="'required|min:6|max:12'" name="password"
                                               data-vv-as="Password" class="form-control" placeholder="Password"
                                               type="password">
                                    </div>
                                    <small v-if="errors.has('password')" class="text-danger">
                                        {{ errors.first('password') }}
                                    </small>
                                </div>
                                <div class="text-center">
                                    <button @click="loginUser" type="button" class="btn btn-primary btn-block my-4">
                                        <i :class="{'loader': loading}"></i> {{loginButton}}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-6 text-left">
                            <router-link class="text-light text-primary" :to="{name: 'forgot-password'}">
                                <small>Forgot Password ?</small>
                            </router-link>
                        </div>
                        <div class="col-6 text-right">
                            <router-link class="text-light text-primary" :to="{name: 'register'}">
                                <small>Create new account</small>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import router from "../router";
import axios from "axios";
import _ from "lodash";
import vueHeadful from "vue-headful";

export default {
  data() {
    return {
      loading: false,
      loginButton: "Login",
      email: "",
      password: ""
    };
  },
  methods: {
    loginUser() {
      this.$validator
        .validateAll()
        .then(result => {
          if (!result) {
            return;
          }

          this.loginButton = "";
          this.loading = true;
          axios({
            method: "post",
            url: "admin/login",
            data: {
              access_token: "",
              email: this.email,
              password: this.password
            },
            headers: {
              "Content-Type": "application/json"
            }
          })
            .then(
              result => {
                let token = result.data.auth;
                let user = result.data.user;
                localStorage.setItem("access_token", token.access_token);
                localStorage.setItem("expires_at", token.expires_at);
                localStorage.setItem("user_fullName", user.full_name);
                localStorage.setItem("user_username", user.username);

                router.push({ path: "/dashboard" });
              },
              error => {
                this.loading = false;
                this.loginButton = "Login";
                this.$swal(
                  "Error",
                  "There was an error. Please try again",
                  "error"
                );
                let errors = error.response.data.error;
                for (let error in errors) {
                  this.$noty.error("Error: " + _.startCase(errors[error][0]));
                }
              }
            )
            .catch(e => {
              this.loading = false;
              this.loginButton = "Login";
              console.log("catch " + e.response);
            });
        })
        .catch(e => {
          console.log(e.response);
        });
    },
    clearFields() {
      this.email = "";
      this.password = "";
    }
  },
  computed: {
    isComplete() {
      return this.email && this.password;
    }
  },
  components: {
    "vue-headful": vueHeadful
  }
};
</script>
<style scoped>
.wrapper {
  height: 100vh !important;
  width: 100vw !important;
}
</style>
